// @flow

import _ from "lodash";
import * as React from "react";
import { Modal, Button } from "react-bootstrap";

import "./PostResponseModal.css";

const modalStyle = {
  position: "fixed",
  zIndex: 1040,
  transition: "unset",
  opacity: 1
};
const backdropStyle = {
  ...modalStyle,
  zIndex: 1000,
  backgroundColor: "#000",
  opacity: 0.5
};

type Props = {
  visible: boolean,
  onClose: () => void,
  secondsRemaining: number
};

const PostResponseModal = (props: Props) => (
  <Modal
    // aria-labelledby="modal-label"
    style={modalStyle}
    backdrop="static"
    backdropStyle={backdropStyle}
    show={props.visible}
    onHide={props.onClose}
  >
    <div className="PostResponseModal">
      <h4 id="modal-label">Thanks for your response!</h4>
      <p>Next, try it with more time.</p>
      <Button
        className="PostResponseModal-Button"
        bsSize="large"
        onClick={props.onClose}
      >
        Get {_.round(props.secondsRemaining)} more seconds
      </Button>
    </div>
  </Modal>
);

export default PostResponseModal;



// WEBPACK FOOTER //
// ./src/components/Task/PostResponseModal.js